import styled from "styled-components";
import { TopicResult } from "common/topic/dto/TopicResult";
import {
  InputWayTextCharElement,
  inputWayTextFieldGet,
} from "common/topic/input_way_text";
import { useTextCharSplit } from "hooks/asocijator/topic/input_way_text/useTextCharSplit";
import { TopicRelateAnswerProvider } from "components/pages/answer/RelatePlay/provider/TopicRelateAnswer";
import { getInputWayTextGroupsByLine } from "./TopicInputWayTextPlay.logic";
import InputWayTextPlayGroup from "./InputWayTextPlayGroup";

export type TopicInputWayTextPlayProps = {
  topic: TopicResult;
};

const TopicInputWayTextPlay = ({ topic }: TopicInputWayTextPlayProps) => {
  const textCharElements: InputWayTextCharElement[] = useTextCharSplit(topic);
  const textCharElementGroups: InputWayTextCharElement[][] =
    getInputWayTextGroupsByLine(textCharElements);

  return (
    <>
      <Div>
        <pre>{inputWayTextFieldGet(topic)}</pre>
        <pre>{inputWayTextFieldGet(topic, "translation")}</pre>
      </Div>
      <DivPlay>
        <TopicRelateAnswerProvider topicId={topic.id}>
          {textCharElementGroups.map(
            (textCharElementGroup: InputWayTextCharElement[]) => (
              <InputWayTextPlayGroup elements={textCharElementGroup} />
            )
          )}
        </TopicRelateAnswerProvider>
      </DivPlay>
    </>
  );
};

const Div = styled.div`
  margin-top: 0.3rem;
  display: flex;
  gap: 2rem;
  font-size: 2rem;
`;

const DivPlay = styled.div`
  margin-top: 2rem;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default TopicInputWayTextPlay;
